'use strict';

const _ = require('lodash');
const {PARSER_ERRORS} = require('../constants');
const ParserError = require('../errors/ParserError');

module.exports = (input, config) => {
    _.defaults(config, {

    });
    console.log(input, config);
    const rowsIds = config.rows.map((r) => r.id);

    for (const id of rowsIds) {
        if (_.isUndefined(input)) {
            throw new ParserError(PARSER_ERRORS.REQUIRED, [{errorRows: rowsIds}]);
        }
        if (_.isUndefined(input[id])) {
            throw new ParserError(PARSER_ERRORS.REQUIRED, [{errorRows: [id]}]);
        }
        if (!_.isNumber(input[id])) {
            throw new ParserError(PARSER_ERRORS.NOT_NUMBER, [{errorRows: [id]}]);
        }
        if (input[id] < 0) {
            throw new ParserError(PARSER_ERRORS.MIN_NUMBER, [{min: 0, errorRows: [id]}]);
        }
    }

    if (config.max === null) {
        config.max = config.rows.length;
    }

    if (config.currentMax < config.max || config.currentMax === 0) {
        throw new ParserError(PARSER_ERRORS.MIN_CHOICES_ORDER, [{min: config.max}]);
    }

    return input;
};
